import { Ng1StateDeclaration } from '@uirouter/angularjs';
import * as Resolve from '../Resolve';
import { Roles, editWidgetShapeState, editGroupWidgetShapeState } from '../../common/constants';

const routeData = {
    displayName: 'Edit shapes',
    visible: false,
    editRoles: [Roles.master, Roles.engineer],
    editButtonVisibility: () => true,
    editButtonDisabled: () => true
};

//const routeTemplate = '<wt-edit-shapes></wt-edit-shapes>';

const routeResolve = {
    auth: Resolve.authResolve,
    connected: Resolve.connectedResolve,
    roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
};

const states: Ng1StateDeclaration[] = [
    {
        name: editWidgetShapeState,
        //template: routeTemplate,
        component: 'wtEditShapesDashboard',
        url: '/:dashboardGuid/editWidget/:widgetGuid/:beginDate/:endDate/shapes',
        resolve: routeResolve,
        data: routeData
    }, {
        name: editGroupWidgetShapeState,
        //template: routeTemplate,
        component: 'wtEditShapesGroup',
        url: '/:groupGuid/editWidget/:widgetGuid/:beginDate/:endDate/shapes',
        resolve: routeResolve,
        data: routeData
    }
];

export default states;